<template>
    <div
        id="preview"
        class="card card-primary"
    >
        <div class="card-header">
            <div class="row">
                <div class="col col-md-8">
                    <ul class="resolution-changer">
                        <li
                            title="Поместить на экране"
                            :class="{selected: mode == 'full'}"
                            @click="setSize(0, 0, 'full')"
                        >
                            <i class="fa fa-pencil-square-o" />
                        </li>
                        <li
                            title="Компьютер"
                            :class="{selected: mode == 'desktop'}"
                            @click="setSize(1280, 1024, 'desktop')"
                        >
                            <i class="fa fa-desktop" />
                        </li>
                        <li
                            title="Ноутбук"
                            :class="{selected: mode == 'laptop'}"
                            @click="setSize(1024, 768, 'laptop')"
                        >
                            <i class="fa fa-laptop" />
                        </li>
                        <li
                            title="Планшет"
                            :class="{selected: mode == 'tablet'}"
                            @click="setSize(800, 600, 'tablet')"
                        >
                            <i class="fa fa-tablet" />
                        </li>
                        <li
                            :title="mode != 'mobile' ? 'Мобильный' : 'Повернуть'" 
                            :class="{selected: mode == 'mobile'}"
                            @click="toggleMobile"
                        >
                            <i
                                class="fa fa-mobile"
                                :class="{'fa-rotate-90': !rotation && mode == 'mobile'}"
                            />
                        </li>
                    </ul>
                </div>
                <div class="col col-md-4">
                    <div
                        v-if="w || h"
                        class="input-group resolution-inputs appear"
                    >
                        <input 
                            v-model.number="w"
                            type="number"
                            min="0"
                            step="4"
                            class="form-control"
                            placeholder="Ширина"
                            @input="resetMode"
                        >
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i
                                    title="высота"
                                    class="fa fa-times"
                                />
                            </span>
                        </div>
                        <input
                            v-model.number="h"
                            type="number"
                            min="0"
                            step="4"
                            class="form-control"
                            placeholder="Высота"
                            @input="resetMode"
                        >
                    </div>
                </div>
            </div>
        </div>
        <div
            ref="preview"
            class="panel-body pt-5 pb-5 pl-3 pr-3" 
            :class="{'hide-dashes': mode !== 'full'}"
            align="center"
            style="overflow-y: auto; overflow-x: hidden;"
        >
            <div
                :style="{width: w ? w+'px' : 'auto', height: h ? h+'px' : 'auto'}"
            >
                <slot ref="previewContent" />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Preview',
        data: function() {
            return { 
                w: 0,
                h: 0,
                mode: 'full',
                rotation: false,
            }
        },
        methods: {
            setSize: function (w, h, mode) {
                this.w = w;
                this.h = h;
                this.mode = mode;
                this.rotation = this.w > this.h ? false : true; 

                this.$nextTick(function(){
                    this.$refs.preview.scrollLeft = (this.w - this.$refs.preview.offsetWidth)/2;
                });
            },
            resetMode: function() {
                if (!this.w && !this.h) {
                    this.mode = 'full';
                }
                this.rotation = this.w > this.h ? false : true; 
            },
            rotate: function() {
                [this.w, this.h] = [this.h, this.w];
                this.rotation = this.w > this.h ? false : true; 
            },
            toggleMobile: function() {
                if (this.mode !== 'mobile') {
                    this.setSize(300, 600, 'mobile')
                } else {
                    this.rotate()
                }
            }
        },
    }
</script>
